<template>
  <div>
    <!-- DIALOGS -->  
    <FileImportDialog :alvqaContext="alvqa + '-list'">
      <template v-slot:importOptions>
        <v-row v-if="isMappingImport">
          <v-col>
            <BaseEditPageDropdown
                :context="context"
                field="ImportSelectedMapping"
                :label="$t('lang_GENERIC_CAPTION_ABBREVIATION')"
                :items="mappingAbbreviations"
                :clearable="false"
                :withMargin="false"
                :alvqa="alvqa + '-mapping-import-dropdown-select-abbreviation'"
              />
          </v-col>
        </v-row>
        <v-row v-if="isMappingImport" justify="center">
          <v-col>
            <BaseEditPageTextField
              :context="context"
              field="ImportTags"
              :label="$t('lang_GENERAL_CAPTION_ADD_TAG')"
              :withMargin="false"
              :alvqa="alvqa + '-list-import-dialog-textfield-tags'"
            />
          </v-col>
        </v-row>
      </template>
    </FileImportDialog>
		<SelectionRequiredDialog /> 

    <LabelReleasesCoverImageUploadDialog :alvContext="alvqa + '-list'" />

		<DeletionDialog context="SelectedLabelReleases" />	
		<ManageTagsDialog 
			context="LabelReleases" 
			dir='label/releases'
			idAttributeName='releaseIds'
		/>
    <ErrorDialog />

    <!-- Digital Distribution Dialogs -->
    <LabelReleasesDeliveryDialog />
    <LabelReleasesValidationErrorDialog />

    <LabelReleasesExportDialog />
    <LabelTestReleasesDialog />

		<BaseListPage
      headline="lang_LABEL_RELEASES"
      :context="context"
      searchCols="2"
      :alvqa="alvqa"
      :stickyHeader="true"
    >

    <!-- FILTERS -->
    <template v-slot:filter>
      <v-col cols="3">
        <DropdownFilter 
          :context="context + 'LabelsFilter'"
          label="lang_LABEL_RELEASES_FILTER_CAPTION_CATALOGS"
          :items="labelsItems"
          :alvqa="alvqa + '-list-dropdown-labels'"
        />
      </v-col>
      <v-col cols="1">
					<DropdownFilter 
						:context="context + 'QualityFilter'"
						label="lang_GENERIC_CAPTION_FILTER"
						:items="qualityItems"
						:alvqa="alvqa + '-list-dropdown-quality'"
					/>
				</v-col>
      <v-col cols="2">
        <DropdownFilter 
          :context="context + 'DigitalDistributionStatus'"
          label="lang_LABEL_RELEASES_CAPTION_DIGITAL_DISTRIBUTION"
          :items="releaseDistributionStatusItems"
          :alvqa="alvqa + '-list-dropdown-status'"
        />
      </v-col>
      <v-col cols="1">
          <DropdownFilter 
              :context="context + 'YearsFilter'"
              label="lang_GENERIC_PERIOD_FILTER_OPTION_YEAR"
              itemText="text"
              :items="yearsOptions"
              :alvqa="alvqa + '-list-dropdown-years-filter'"
          />
      </v-col>
      <v-col cols="2">
          <DropdownFilter 
              :context="context + 'CountryOfOriginFilter'"
              label="lang_LABEL_RELEASES_CAPTION_MANUFACTURING"
              :items="countryOfOriginItems"
              :alvqa="alvqa + '-list-dropdown-country-of-origin'"
          />
      </v-col>
    </template>

    <!-- DATA TABLE COMPONENT -->
      <template v-slot:dataTable>
        <BaseDataTableList
          :headers="headers"
          :context="context"
					:alvqa="alvqa"
          :hasServerSideSorting="true"
          :stickyTopSlot="true"
        >
        <!-- TOPSLOT: actions, imports etc. -->
          <template v-slot:topSlot> <ReleasesTopSlot /> </template> 
        <!-- DATA TABLE CONTENT: columns -->
          <template v-slot:body="{ item }">
						<ExpandIcon 
							:isExpanded="item.isExpanded" 
							:alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-expand'"
						/>
            <td>
                <v-img 
                    v-if="item.item.cover !== undefined && item.item.cover !== null"
                    :src="item.item.cover"
                    :alvqa="alvqa + '-list-row-' + item.item.alvId + '-image'"
                    width="40px"
                ></v-img>
                <v-img 
                    v-else
                    :src="require('@/assets/default_picture/default.jpg')"
                    :alvqa="alvqa + '-list-row-' + item.item.alvId + 'cover-image'"
                    width="40px"
                ></v-img>
            </td>
						<td class="ellipsis">
							<BaseTooltip>
								<template v-slot:text>{{ item.item.title}}</template>
								<template v-slot:content>
                  <span :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-release-title'">
                    {{ item.item.title}}
                  </span>
                </template>
							</BaseTooltip>
						</td>
            <td class="text-right" :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-tracks'">
              {{ item.item.tracks }}
            </td>
            <!-- <td class="ellipsis">
							<BaseTooltip>
								<template v-slot:text>{{ $alvPlugin.getArtistOrPerformerName(item.item.performer) }}</template>
								<template v-slot:content>
                  <span :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-performer'">
                    {{ $alvPlugin.getArtistOrPerformerName(item.item.performer) }}
                  </span>
                </template>
							</BaseTooltip>
            </td> -->
            <td class="ellipsis">
							<BaseTooltip>
								<template v-slot:text>{{ item.item.displayArtist }}</template>
								<template v-slot:content>
                  <span :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-display-artist'">
                    {{ item.item.displayArtist }}
                  </span>
                </template>
							</BaseTooltip>
            </td>
            <td class="no_ellipsis">
              <BaseTooltip>
								<template v-slot:text>{{ item.item.ean }}</template>
								<template v-slot:content>
                  <span :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-ean'">
                    {{ item.item.ean }}
                  </span>
                </template>
							</BaseTooltip>
            </td>
            <td class="no_ellipsis">
							<BaseTooltip>
								<template v-slot:text>{{ item.item.catalogueNumber }}</template>
								<template v-slot:content>
                  <span :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-gema-catalogue-number'">
                    {{ item.item.catalogueNumber }}
                  </span>
                </template>
							</BaseTooltip>
            </td>
            <td class="no_ellipsis">
								<span :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-date-retail'">
                  {{ item.item.dateRetail !== null ? $d(new Date(item.item.dateRetail), 'alvDateFormat') : '' }}
                </span>
            </td>
            <td class="no_ellipsis">
								<span :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-date-digital'">
                  {{ item.item.dateDigital !== null ? $d(new Date(item.item.dateDigital), 'alvDateFormat') : '' }}
                </span>
            </td>
            <td class="no_ellipsis">
              <BaseIcon   
                  :alvqa="alvqa + '-list-row-' + item.item.id + '-icon-upload-picture'"
                  icon="photo" 
                  :tooltipText="'lang_LABEL_RELEASES_UPLOAD_COVER_IMAGE'"
                  :color="item.item.cover ? 'buttonStandard' : 'standardBrownIcon'"
                  @click.stop="showImageUploadDialog(item.item)"
              /> 
            </td>
          </template>
        <!-- EXPAND: Read Only View -->
          <template v-slot:expandSlot="{ id }"><LabelReleaseReadOnly :itemId='id' /></template>
        </BaseDataTableList>
      </template>
		</BaseListPage>     
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import BaseDataTableList from '@/components/_base/BaseDataTableList'
import BaseListPage from '@/components/_base/BaseListPage'
import BaseTooltip from '@/components/_base/BaseTooltip'
import ExpandIcon from '@/components/_buttons/ExpandIcon'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'

import ReleasesTopSlot from "./ReleasesTopSlot"
import LabelReleaseReadOnly from "./_readonly/LabelReleaseReadOnly"
import DropdownFilter from '@/components/_filters/DropdownFilter'

import FileImportDialog from '@/components/_dialogs/FileImportDialog'
import ErrorDialog from '@/components/_dialogs/ErrorDialog'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import SelectionRequiredDialog from '@/components/_dialogs/SelectionRequiredDialog'
import ManageTagsDialog from '@/components/_dialogs/ManageTagsDialog'
import LabelReleasesDeliveryDialog from './_dialogs/LabelReleasesDeliveryDialog'
import LabelReleasesValidationErrorDialog from './_dialogs/LabelReleasesValidationErrorDialog'
import LabelReleasesCoverImageUploadDialog from './_dialogs/LabelReleasesCoverImageUploadDialog'
import LabelReleasesExportDialog from './_dialogs/LabelReleasesExportDialog'
import LabelTestReleasesDialog from './_dialogs/TestCalculationReleaseDialog'

import { DropdownLabelReleasesDigitalDistributionStatus } from '@/assets/dropdowns/alvDropdowns.js'


export default {
  name: 'ReleasesList',
  components: { 
    BaseDataTableList,
    BaseListPage,
    BaseTooltip,
    ExpandIcon,
    BaseIcon,
    BaseEditPageTextField,
    BaseEditPageDropdown,

    ReleasesTopSlot,
    LabelReleaseReadOnly,
    DropdownFilter,

    FileImportDialog,
    DeletionDialog,
    SelectionRequiredDialog,
    ManageTagsDialog,
    LabelReleasesDeliveryDialog,
    LabelReleasesValidationErrorDialog,
    LabelReleasesCoverImageUploadDialog,
    ErrorDialog,
    LabelReleasesExportDialog,
    LabelTestReleasesDialog
  },
  data() {
    return {
      context: "LabelReleases",
      alvqa: "label-releases"
    }
  },
  computed: {
    ...mapGetters(['getLabelReleasesSearch', 'getSelectedLabelReleasesLabelsFilter']),

		/** Returns an Array with header-objects with props.
     *  @return {[{text: String, align: string, sortable: string, value: string}]} props of the header */
    headers() {
      return [
        {
            text: '', 
            value: 'data-table-select', 
            align: 'center',
            width: "60px",
            sortable: false,
            class: 'text-no-wrap'
        },
        {
            text: '', 
            value: 'cover', 
            align: 'center',
            width: "60px",
            sortable: false,
            class: 'text-no-wrap'
        },   
        {
            text: '', 
            value: 'data-table-expand',
            align: 'center', 
            width: "48px",
            sortable: false,
            class: 'text-no-wrap'
        },
        {
            text: this.$t('lang_LABEL_RELEASES_CAPTION_TITLE'), 
            value: 'title', 
            align: 'left', 
            sortable: true,
            class: 'text-no-wrap'
        }, 
        {
            text: this.$t('lang_LABEL_RELEASES_CAPTION_NUMBER_OF_TRACKS'), 
            value: 'tracks',
            align: 'right', 
            sortable: false,
            width: "80px",
            class: 'text-no-wrap'
        }, 
        {
            text: this.$t('lang_LABEL_RELEASE_CAPTION_DISPLAY_ARTIST'), 
            value: 'displayArtist',
            align: 'left', 
            sortable: true,
            class: 'text-no-wrap'
        }, 
        {
            text: this.$t('lang_LABEL_RELEASES_CAPTION_EAN_UPC'), 
            value: 'ean',
            align: 'left', 
            sortable: false, 
            class: 'text-no-wrap'
        },
        {
            text: this.$t('lang_LABEL_RELEASE_CAPTION_CATALOGUE_NUMBER'), 
            value: 'catalogueNumber', 
            align: 'left', 
            sortable: true, 
            class: 'text-no-wrap'
        },
        {
            text: this.$t('lang_LABEL_RELEASES_CAPTION_DATE_PHYSICAL'), 
            value: 'dateRetail', 
            align: 'left', 
            sortable: true, 
            class: 'text-no-wrap'
        },
        {
            text: this.$t('lang_LABEL_RELEASES_CAPTION_DATE_DIGITAL'), 
            value: 'dateDigital',
            align: 'left', 
            sortable: true, 
            class: 'text-no-wrap'
        },
        {
            text: '', 
            value: 'uploadPicture',
            align: 'right',
            sortable: false,
            width: "70px",
            class: 'text-no-wrap'
        },
        {
            text: '', 
            value: 'editForm',
            align: 'right',
            sortable: false,
            width: "70px",
            class: 'text-no-wrap'
        }
      ]
    },

    qualityItems() {
      return[ 
        {
          text: this.$t('lang_LABEL_TRACKS_DROPDOWN_QA_FILTER_NO_ARTIST_AZ'), 
          value: 'noArtistAz',
          alvqa: this.alvqa + '-list-dropdown-quality-no-artist-az'
        },
        {
          text: this.$t('lang_LABEL_RELEASES_QA_FILTER_OPTION_NO_CONTRACT'), 
          value: 'noContracts',
          alvqa: this.alvqa + '-list-dropdown-quality-no-contracts'
        }
      ]
    },

    countryOfOriginItems() {
      return [
        {
          text: this.$t('lang_GENERIC_CAPTION_DOMESTIC'),
          value: 'domestic',
          alvqa: this.alvqa + '-list-dropdown-country-of-origin-domestic'
        },
        {
          text: this.$t('lang_GENERIC_CAPTION_FOREIGN'),
          value: 'foreign',
          alvqa: this.alvqa + '-list-dropdown-country-of-origin-foreign'
        }
      ]
    },

    labelsItems() { 
        let labels = []
        let labelsDropdown = []
        let selectedLabelCompany = this.$store.getters.getSelectedLabelCompanyId
        
        // TODO: Breadcrumb issue (sometimes a object is set and sometimes only the id of the company) also causes a problem here,
        // need to change that as soon as breadcrumb issue is fixed!
        if(selectedLabelCompany && typeof selectedLabelCompany === 'object' && selectedLabelCompany.constructor === Object) {
            selectedLabelCompany = selectedLabelCompany.id
        }

        this.$store.getters.getLabelCompanies.forEach((labelCompany) => {
            if(labelCompany.labels != null) {
                if (labelCompany.id == selectedLabelCompany)
                labels = labels.concat(labelCompany.labels)
            }
        })
        labels.forEach((label) => {
            labelsDropdown.push({
                "value": parseInt(label.id),
                "text": label.name_alv + ' (' + label.alvId + ')',
                "alvqa": this.alvqa + '-list-dropdown-label-' + parseInt(label.id)
            })
        })
        if(labelsDropdown === undefined || labelsDropdown.length === 0 || labelsDropdown.error === 1) 
            labelsDropdown = []
        return labelsDropdown.sort(this.sortLabelItemsList)
    },
    releaseDistributionStatusItems() {
        return DropdownLabelReleasesDigitalDistributionStatus
    },
    yearsOptions(){
        let years = []  
        let maxYear = new Date().getFullYear()+1

        for(let i = maxYear; i >= 2008; i--) {
            years.push(
                {
                    text: i.toString(),
                    value: i, 
                    alvqa: this.alvqa + '-dropdown-period-selector-years-' + i
                }
            )
        } 
        return years
    },
    isMappingImport() {
      return this.$store.getters.getSelectedFileImport === 'mappingImport';
    },
    mappingAbbreviations() {
			let mappingsList = this.$store.getters.getMappings
      let retArr = []
      
      mappingsList.forEach((v) => {
				if (v.direction !== 'import') return;
        retArr.push({
            value: v.alvId,
            text: v.abbreviation,
            alvqa: this.alvqa + `-import-mapping-${v.alvId}`,
            disabled: v.columnMappingsCount === 0, // Disable if no column mappings exist for this mapping
        })
      })
      
      // Sort by ALVID descending (highest first), with disabled options at the end
      retArr.sort((a, b) => {
        if (a.disabled === true) return 1; // Put disabled at the end
        if (b.disabled === true) return -1;
        const alvIdA = parseInt(a.value.replace(/\D/g, '')) || 0
        const alvIdB = parseInt(b.value.replace(/\D/g, '')) || 0
        return alvIdB - alvIdA
      })
      // Auto-select first option and show warning if none (no watchers, contained here)
      if (this.isMappingImport && retArr.length > 0) {
        const selected = this.$store.getters.getLabelReleasesDetailsImportSelectedMapping
        const found = retArr.find(o => o.value === selected)
        if (selected === null || selected === undefined || !found) {
          this.$store.commit('setLabelReleasesDetailsImportSelectedMapping', retArr[0].value)
        }
      }
      if (this.isMappingImport && retArr.length === 0 && this.$store.getters.getIsLoading === false) {
        const warn = this.$t('lang_GENERIC_MESSAGE_WARNING_NO_MAPPINGS_AVAILABLE_FOR_DOMAIN')
        this.$store.commit('setImportDialogText', `<span class="error--text">${warn}</span>`)
      }
      
      return retArr
		},
  },
  methods: {    
    showImageUploadDialog(item){
            this.$store.commit('setShowImageUploadOnlyDialog',true)
            this.$store.commit('setLabelReleasesDetails', item)
    },
    sortLabelItemsList( a, b ) {
        if ( a.text < b.text ){
            return -1;
        }
        if ( a.text > b.text ){
            return 1;
        }
        return 0;
    },
    getMappings() {
      this.$store.commit('setSelectedMappingsDomainsFilter', 'label_releases')
      this.$store.dispatch('fetchMappingsByDomain')
    },
  },
  created() {		
    this.$store.commit('setSelectedLabelReleasesLabelsFilter', [])
    // copied from WorksList => this.$store.commit('setSelectedWorksAction', [])
    this.getMappings()
  } 
}
</script>